// Money formatting for the storefront. Prices are stored as plain PKR integers
// (see storefront/data/products.js) and rendered through formatPKR everywhere.

const pkr = new Intl.NumberFormat('en-PK', { maximumFractionDigits: 0 });

/** Format a rupee amount as `Rs 12,500`. */
export function formatPKR(amount) {
  return `Rs ${pkr.format(Math.round(Number(amount) || 0))}`;
}
